/*
  firebase implictly stores the first initialized application asd the main application.
  so firebase is effectively an app global, but we do not need to keep track
  of the object ourself, since firebase does it internally. 
*/


import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

import loglevel from 'loglevel';

import { retry } from 'zoomforth_zfutils/retry.js';

var firebaseConfig;

export const initFirebase = ({ 
  authToken, 
  apiKey, 
  authDomain, 
  databaseURL, 
  applicationId, 
  accountId
})=> {

  if (firebaseConfig) {
    throw new Error('We currently only expect there to be a single firebase app');
  }
  
  firebaseConfig = {
    authToken, apiKey, authDomain, databaseURL, applicationId, accountId
  };

  firebase.initializeApp({
    apiKey,
    authDomain,
    databaseURL
  });

  firebase.auth().signInWithCustomToken(authToken)

    .catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;

      loglevel.error(
        'Firebase auth error: ', 
        errorCode, 
        errorMessage, 
        firebaseConfig
      );

      // ...
    });

  return firebase;
};

export const getFirebase = ()=> {
  // the firebase object, once initialized, IS the app global we care about
  return firebase;
};

// in some instances the firebase API may not have finished the authentication
// step. in order to ensure that firebase is ready for use you may use this
// promise before sending and receiving events.
export const getFirebaseWithRetry = (delay=1000, retries=5)=> {
  return retry(()=> {
    return new window.Promise((resolve, reject)=> {
      const firebase = getFirebase();

      if (!firebase.apps.length) {
        reject();
      }

      return resolve(firebase);
    });
  }, delay, retries);
};

export const getFirebaseConfig = ()=> {
  return firebaseConfig;
};

export const getAccountScopedFirebaseRef = (path)=> {
  /*
    path is optional. 
    if passed it will give you the ref at that path in relation to the base ref
    if not, you can just get the account scoped ref back
  */
  if (!path) {
    path = '';
  } else if (path[0] != '/'){
    path = '/' + path;
  }
  return getFirebase().database().ref(
    `accounts/${getFirebaseConfig().accountId}/${getFirebaseConfig().applicationId}${path}`
  );
};

